export default __webpack_public_path__ + "static/media/title_sp.9a22fe31.png";